import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const edition = { state: localStorage.getItem("cl_state") || "ga" };
export const setEditionState = (st) => { edition.state = st; localStorage.setItem("cl_state", st); };
http.interceptors.request.use((cfg) => {
  if (/^\/subjects/.test(cfg.url || "")) cfg.params = { state: edition.state, ...(cfg.params || {}) };
  return cfg;
});

http.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && cfg && !cfg._retry && !/auth\/(login|register|refresh)/.test(cfg.url)) {
      cfg._retry = true;
      try {
        await http.post("/auth/refresh");
        return http(cfg);
      } catch { /* fall through */ }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const GRADES = ["K", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
export const BABY_LABEL = "Baby / Toddler (0–3)";
export const gradeLabel = (g) => (g === "K" ? "Kindergarten" : `Grade ${g}`);

export async function streamSSE(path, body, onDelta) {
  const send = () => fetch(`${API}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  let res = await send();
  if (res.status === 401) {
    await http.post("/auth/refresh");
    res = await send();
  }
  if (!res.ok || !res.body) throw new Error(`Request failed (${res.status})`);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const ev of events) {
      const line = ev.trim();
      if (!line.startsWith("data:")) continue;
      const data = JSON.parse(line.slice(5));
      if (data.error) throw new Error(data.error);
      if (data.delta) onDelta(data.delta);
    }
  }
}
